import React, { useEffect, useState } from "react";
import Breadcrumb from "../../../../layouts/full-layout/breadcrumb/Breadcrumb";
import FeatherIcon from "feather-icons-react";
import { GetCandidateCV } from "../../../../services/human-resource";
import { useTheme } from "@mui/material/styles";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import {
  Card,
  CardContent,
  TableHead,
  Grid,
  Box,
  Table,
  TableBody,
  TableCell,
  TablePagination,
  TableRow,
  TableFooter,
  IconButton,
  TableSortLabel,
  TableContainer,
  Paper,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import CustomTextField from "../../../../components/forms/custom-elements/CustomTextField";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import { routes } from "../../../../routes/routes";
import { useNavigate } from "react-router";
import DeleteIcon from "@mui/icons-material/Delete";
import { toast } from "react-toastify";
import { Form, FormikProvider, useFormik } from "formik";
import { AddCandidateCV } from "../../../../services/human-resource";
import CVValidation from "../../../../validationSchema/AddCV";
import { AddCV } from "../AddResume/AddCV";
import PropTypes from "prop-types";
import { getAddNewResumeObj } from "../AddResume/EmptyAddResume";
import { enums } from "../../../../enums/Enums";
import { findCurrectPermission } from "../../../../helpers/roles-and-permissions";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

const BCrumb = [
  {
    to: "/",
    title: "HR Management",
  },
  {
    title: "All Candidate CV",
  },
];
function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};
const AllCandidateCV = () => {
  const [CandidateCV, SetCandidateCV] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [page, setPage] = useState(0);
  const [orderDirection, setOrderDirection] = useState("desc");
  const [valueToOrderBy, setValueToOrderBy] = useState("Id");
  const [totalRecords, setTotalRecords] = useState();
  const [searchValue, setSearchValue] = useState("");
  const [open, setOpen] = useState(false); // State to control the popup dialog
  const [selectCandidate, setSelectCandidate] = useState(getAddNewResumeObj());
  const [addcvpermission, setAddcvpermission] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    formik.resetForm();
  };
  useEffect(() => {
    const addCandidateCVppermission = findCurrectPermission(
      enums.UserPermissionNames.HR_AddCandidateResume
    );
    setAddcvpermission(addCandidateCVppermission);
  }, []);
  const formik = useFormik({
    initialValues: selectCandidate,
    onSubmit: (values, { resetForm }) => {
      addResume(values, resetForm);
    },
    validationSchema: CVValidation,
  });

  const addResume = async (values, resetForm) => {
    const formData = new FormData();
    formData.append("FirstName", values.firstName);
    formData.append("MiddleName", values.middleName);
    formData.append("LastName", values.lastName);
    formData.append("Attachment", values.cv);

    try {
      const response = await AddCandidateCV(formData);
      if (response?.status === 200) {
        toast.success("CV Added Successfully");
        resetForm();
        handleClose();
        getCandidateCV(); // Refresh the list after adding a new CV
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handlRequestSort = (property) => {
    const isAscending = valueToOrderBy === property && orderDirection === "asc";
    setValueToOrderBy(property);
    setOrderDirection(isAscending ? "desc" : "asc");
  };

  useEffect(() => {
    getCandidateCV();
  }, [page, rowsPerPage, valueToOrderBy, orderDirection, searchValue]);

  const getCandidateCV = async () => {
    const start = rowsPerPage * page;
    const length = rowsPerPage;
    const sortValue = `${valueToOrderBy} ${orderDirection}`;
    const searchKeyword = searchValue ? searchValue : null;
    const data = {
      start: start,
      length: length,
      sortExpression: sortValue,
      searchKeyword: searchKeyword,
    };
    try {
      const response = await GetCandidateCV(data);
      if (response && response.data) {
        SetCandidateCV(response?.data?.result);
        setTotalRecords(response.data.totalRecords);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <Breadcrumb title="All Candidate CV" items={BCrumb} />
      <Card sx={{ p: 0 }}>
        <Box
          display="flex"
          alignItems="center"
          p={2}
          sx={{
            backgroundColor: "primary.light",
            color: "primary.main",
          }}
        >
          <FeatherIcon icon="alert-circle" width="18" />
          <Box sx={{ ml: 1 }}>All Candidate CV</Box>
          {addcvpermission && (
            <Button
              variant="contained"
              color="primary"
              onClick={handleClickOpen}
              sx={{ ml: "auto" }}
            >
              Add Candidate CV
            </Button>
          )}
        </Box>
        <CardContent>
          <Grid item lg={12} md={12} sm={12} style={{ overflow: "auto" }}>
            <TableContainer
              component={Paper}
              sx={{ maxHeight: 450, overflow: "auto" }}
            >
              <Table
                aria-label="custom pagination table"
                stickyHeader
                sx={{ whiteSpace: "nowrap" }}
              >
                <TableHead sx={{ position: "sticky", top: 0, zIndex: 1 }}>
                  <TableRow>
                    <TableCell>
                      <TableSortLabel
                        active={valueToOrderBy === "PersonName"}
                        direction={
                          valueToOrderBy === "PersonName"
                            ? orderDirection
                            : "desc"
                        }
                        onClick={() => handlRequestSort("PersonName")}
                      >
                        PersonName
                      </TableSortLabel>
                    </TableCell>
                    <TableCell>
                        CV
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {CandidateCV?.map((rows) => (
                    <TableRow key={rows?.id}>
                      <TableCell
                        sx={{
                          whiteSpace: "normal",
                          wordWrap: "break-word",
                          maxWidth: 300,
                        }}
                      >
                        {rows?.personName}
                      </TableCell>
                      <TableCell sx={{ maxWidth: 100 }}>
                        {rows?.cv && (
                          <Box display="flex" alignItems="center">
                            <Tooltip title="View CV">
                              <IconButton
                                href={rows.cvPath}
                                target="_blank"
                                rel="noopener noreferrer"
                                color="primary"
                              >
                                <RemoveRedEyeOutlinedIcon />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Download CV">
                              <IconButton
                                href={rows.cvPath}
                                download
                                color="primary"
                              >
                                <FileDownloadIcon />
                              </IconButton>
                            </Tooltip>
                             
                          </Box>
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
                <TableFooter>
                  <TableRow></TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          </Grid>
          <Box style={{ display: "flex", justifyContent: "flex-end" }}>
            <TablePagination
              rowsPerPageOptions={[
                5,
                10,
                25,
                { label: "All", value: totalRecords },
              ]}
              colSpan={10}
              count={totalRecords || 0}
              rowsPerPage={rowsPerPage}
              page={page}
              SelectProps={{
                inputprops: { "aria-label": "rows per page" },
                native: true,
              }}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
            />
          </Box>
        </CardContent>
      </Card>

      <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
        <DialogTitle sx={{ textAlign: "center" }}>Add Candidate CV</DialogTitle>
        <DialogContent>
          <FormikProvider value={formik}>
            <Form onSubmit={formik.handleSubmit}>
              <Box sx={{ width: "100%", typography: "body1" }}>
                <AddCV
                  values={formik.values}
                  handleChange={formik.handleChange}
                  setFieldValue={formik.setFieldValue}
                />
              </Box>
            </Form>
          </FormikProvider>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={handleClose} color="secondary" variant="outlined">
            Cancel
          </Button>
          <Button
            onClick={formik.handleSubmit}
            color="primary"
            variant="contained"
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default AllCandidateCV;
